<app-header />
<main class="flex bg-gray-50">
  <aside class="flex flex-col top-0 px-4 text-gray-900 border-r border-gray-200 z-20 flex-shrink-0 w-64 overflow-y-auto bg-white">
    <nav>
      <ul>
        <li class="relative py-3">
            <a class="cursor-pointer inline-flex items-center text-sm transition-colors duration-150 hover:text-red-600" routerLink="/dashboard/chip-registration" routerLinkActive="active-link">
                {{ "chipRegistration.title" | translate }}
            </a>
        </li>
        <li class="relative py-3">
            <a class="cursor-pointer inline-flex items-center text-sm transition-colors duration-150 hover:text-red-600" routerLink="/dashboard/buy-ed" routerLinkActive="active-link">
                {{ "common.buyEd" | translate }}
            </a>
        </li>
        <li class="relative py-3">
            <a class="cursor-pointer inline-flex items-center text-sm transition-colors duration-150 hover:text-red-600" routerLink="/dashboard/registered-chips" routerLinkActive="active-link">
                {{ "chipDetails.gridTitle" | translate }}
            </a>
        </li>
        <li class="relative py-3">
            <a class="cursor-pointer inline-flex items-center text-sm transition-colors duration-150 hover:text-red-600"
                routerLink="/dashboard/payments"
                routerLinkActive="active-link">
                {{ "payments.pageTitle" | translate }}
            </a>
        </li>
      </ul>
    </nav>
  </aside>
  <section class="flex flex-col flex-1 w-full p-4 mx-auto main-section">
    <router-outlet />
  </section>
</main>
<app-footer />
